var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeingAuthenticImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 96.46 104.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{mask:url(#mask);filter:url(#luminosity-noclip-2);}.cls-2,.cls-5{mix-blend-mode:multiply;}.cls-2{fill:url(#radial-gradient);}.cls-3{isolation:isolate;}.cls-4{mask:url(#mask-2);}.cls-5{fill:url(#radial-gradient-2);}.cls-6{fill:#c80b29;}.cls-7{fill:#f6f6f6;}.cls-8{fill:#3c3c3b;}.cls-9{fill:#30225f;}.cls-10{filter:url(#luminosity-noclip);}"), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip",
    x: 0,
    y: -7778.24,
    width: 89.28,
    height: 32766,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: -7778.24,
    width: 89.28,
    height: 32766,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 683.56,
    cy: -669.93,
    r: 37.83,
    gradientTransform: "translate(-745.94 -762.1) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#a6a6a6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#a3a3a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#999"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#707070"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#515151"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "luminosity-noclip-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff",
    result: "bg"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "bg"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 0,
    y: 0,
    width: 89.28,
    height: 89.28,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  }))), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient-2",
    cx: 683.56,
    cy: -669.93,
    r: 37.83,
    gradientTransform: "translate(-745.94 -762.1) rotate(90) scale(1.18 1.18)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1d1d1b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#1f1f1d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#272725"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#353533"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#484846"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#61615f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#80807e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#a4a4a3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#cdcdcd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fcfcfc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "About_Us_Page",
    "data-name": "About Us Page"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Content"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Our_principles",
    "data-name": "Our principles"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Being_Authentic_Image",
    "data-name": "Being Authentic Image"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M76.2,76.21a44.64,44.64,0,1,1,0-63.14A44.65,44.65,0,0,1,76.2,76.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M35.78,76.63A38.41,38.41,0,1,1,85,53.58,38.4,38.4,0,0,1,35.78,76.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M32.86,66A30.38,30.38,0,1,0,23,24.19,30.39,30.39,0,0,0,32.86,66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.87,88.61a2.95,2.95,0,1,1-2.95-3A2.95,2.95,0,0,1,50.87,88.61Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M93.13,57.9a47.34,47.34,0,0,1-88.27,0H4.14a48,48,0,0,0,89.71,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M7.3,58.64a3.16,3.16,0,1,1-3.16-3.17A3.15,3.15,0,0,1,7.3,58.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M96.46,57.9A2.95,2.95,0,1,1,93.52,55,2.94,2.94,0,0,1,96.46,57.9Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 47.52,
    y: 87.9,
    width: 0.73,
    height: 7.15
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M50.34,100a2.39,2.39,0,0,1-4.77,0,2.39,2.39,0,1,1,4.77,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M47.92,104.9A4.93,4.93,0,1,1,52.85,100,4.93,4.93,0,0,1,47.92,104.9Zm0-9.51A4.59,4.59,0,1,0,52.51,100,4.58,4.58,0,0,0,47.92,95.39Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.34,28.67a3.54,3.54,0,1,1,3.54-3.54A3.55,3.55,0,0,1,39.34,28.67Zm0-5.92a2.39,2.39,0,1,0,2.38,2.38A2.39,2.39,0,0,0,39.34,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M39.34,58.75a.58.58,0,0,1-.58-.58V45.51a.58.58,0,0,1,.58-.58.57.57,0,0,1,.57.58V58.17A.57.57,0,0,1,39.34,58.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M35.29,45.75a.58.58,0,0,1-.58-.53L34,35.1a.59.59,0,0,1,.53-.62.58.58,0,0,1,.62.53l.75,10.12a.58.58,0,0,1-.53.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.65,28.67a3.54,3.54,0,1,1,3.54-3.54A3.55,3.55,0,0,1,58.65,28.67Zm0-5.92A2.39,2.39,0,1,0,61,25.13,2.39,2.39,0,0,0,58.65,22.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.65,58.75a.58.58,0,0,1-.58-.58V45.51a.58.58,0,1,1,1.15,0V58.17A.58.58,0,0,1,58.65,58.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.7,45.75h0a.57.57,0,0,1-.53-.62L62.87,35A.58.58,0,0,1,64,35.1l-.75,10.12A.58.58,0,0,1,62.7,45.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M42.51,39.36a.62.62,0,0,1-.38-.14L39,36.52a.58.58,0,0,1,0-.88l3.17-2.71A.58.58,0,0,1,43,33a.56.56,0,0,1-.07.81l-2.65,2.27,2.65,2.26a.58.58,0,0,1,.07.82A.6.6,0,0,1,42.51,39.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M51.14,36.65H39.34a.58.58,0,1,1,0-1.15h11.8a.58.58,0,0,1,0,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M55.47,42.33a.58.58,0,0,1-.37-1L57.76,39,55.1,36.78A.59.59,0,0,1,55,36a.58.58,0,0,1,.82-.06L59,38.6a.59.59,0,0,1,.2.44.57.57,0,0,1-.2.44l-3.17,2.71A.59.59,0,0,1,55.47,42.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M58.65,39.62H46.56a.58.58,0,0,1,0-1.15H58.65a.58.58,0,0,1,0,1.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M46,38.43l-.33,4.47c-.07.76-1.28,1.54-2.25,1.68l-.11,0a.57.57,0,0,0-.53.53l-.9,12.13a.35.35,0,0,1-.33.33h-4.5a.35.35,0,0,1-.33-.33l-.9-12.13a.58.58,0,0,0-.52-.53l-.12,0c-1-.14-2.18-.92-2.25-1.66l-.67-9-.57,0,.57-.16a2.7,2.7,0,0,1,2.56-2.73H43.8a2.7,2.7,0,0,1,2.57,2.71l0,.51h1.15l0-.45v0A3.87,3.87,0,0,0,43.81,30h-9a3.86,3.86,0,0,0-3.69,3.86v.23l.67,9c.11,1.26,1.55,2.34,2.92,2.66l.87,11.68a1.52,1.52,0,0,0,1.48,1.4h4.5a1.52,1.52,0,0,0,1.48-1.4l.86-11.68c1.38-.32,2.82-1.4,2.93-2.67l.33-4.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M63.12,30h-9a3.87,3.87,0,0,0-3.69,3.87v.22l.2,2.64h1.16L51.61,34v-.13a2.7,2.7,0,0,1,2.56-2.73h8.94a2.7,2.7,0,0,1,2.57,2.71L65,42.9c-.07.76-1.29,1.54-2.25,1.68l-.11,0a.57.57,0,0,0-.53.53l-.9,12.13a.35.35,0,0,1-.33.33H56.4a.35.35,0,0,1-.33-.33l-.9-12.13a.58.58,0,0,0-.52-.53l-.12,0c-1-.14-2.18-.92-2.25-1.66l-.16-2.14H51L51.13,43c.11,1.26,1.55,2.34,2.92,2.66l.87,11.68a1.51,1.51,0,0,0,1.48,1.4h4.5a1.52,1.52,0,0,0,1.48-1.4l.86-11.68c1.38-.32,2.82-1.4,2.93-2.67l.67-9.11v0A3.87,3.87,0,0,0,63.12,30Z"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeingAuthenticImage);
export default __webpack_public_path__ + "static/media/being-authentic-image.8b1cf645ea17f07f6d0b745ba71d0ae2.svg";
export { ForwardRef as ReactComponent };